export const getClubRoleTkey = (clubRole: string) => {
  return `${clubRole
    .toLowerCase()
    .split(/[ /]/)
    .join('-')}`;
};
